import type { Pair } from '../messages';
import { ruPlural } from '../plural';

/** Collections: the read view, the list screen and the create form. Editing lives in editor.ts. */
export const playlist = {
  'playlist.authorNote': ['заметка автора', 'author’s note'],
  'playlist.blockNumber': ['элемент {n}', 'item {n}'],
  'playlist.updated': ['обновлено {time}', 'updated {time}'],
  'playlist.hiddenTitle': ['Эта подборка скрыта', 'This collection is hidden'],
  'playlist.notFoundTitle': ['Подборка не найдена', 'Collection not found'],
  'playlist.hiddenBody': [
    'Автор сделал её приватной или открыл только для подписчиков.',
    'The author made it private, or opened it to followers only.',
  ],
  'playlist.notFoundBody': [
    'Проверьте ссылку — возможно, подборку удалили.',
    'Check the link — the collection may have been deleted.',
  ],
  'playlist.myPlaylists': ['К моим подборкам', 'To my collections'],
  'playlist.edit': ['Редактировать', 'Edit'],
  'playlist.copyLink': ['Скопировать ссылку', 'Copy link'],
  'playlist.linkCopied': ['Ссылка на подборку скопирована', 'Collection link copied'],
  'playlist.share': ['Поделиться', 'Share'],
  'playlist.isEmpty': ['Подборка пустая', 'This collection is empty'],
  'playlist.isEmptyMine': [
    'Добавьте ссылки из библиотеки и пару строк от себя.',
    'Add links from your library and a couple of lines of your own.',
  ],
  'playlist.isEmptyTheirs': ['Автор ещё ничего не положил сюда.', 'The author has not put anything here yet.'],
  'playlist.openEditor': ['Открыть редактор', 'Open the editor'],
  'playlists.subtitle': ['Ваши маршруты из ссылок и текста', 'Your routes made of links and text'],
  'playlists.new': ['Новая подборка', 'New collection'],
  'playlists.emptyTitle': ['Подборок пока нет', 'No collections yet'],
  'playlists.emptyBody': [
    'Соберите из сохранённых ссылок последовательность со своими комментариями — например «с чего начать» или «что смотреть в дождь».',
    'Turn saved links into a sequence with your own notes — “where to start”, or “what to watch on a rainy day”.',
  ],
  'playlists.createFirst': ['Создать первую подборку', 'Create your first collection'],
  'playlists.titleRequired': [
    'Название обязательно — оно видно в профиле и ленте.',
    'A title is required — it shows on your profile and in the feed.',
  ],
  'playlists.backAll': ['← Все подборки', '← All collections'],
  'playlists.fieldTitle': ['Название', 'Title'],
  'playlists.titlePlaceholder': [
    'Например: С чего начать смотреть Вселенную Marvel',
    'For example: where to start with the Marvel universe',
  ],
  'playlists.fieldDescription': ['Описание', 'Description'],
  'playlists.descriptionHint': ['Одной фразой — о чём этот маршрут.', 'In one phrase — what this route is about.'],
  'playlists.whoSees': ['Кто увидит', 'Who can see it'],
  'playlists.createAndAdd': ['Создать и добавить элементы', 'Create and add items'],
  'count.playlists': [
    (v) => ruPlural(+v.n, 'подборка', 'подборки', 'подборок'),
    (v) => (+v.n === 1 ? '1 collection' : `${v.n} collections`),
  ],
} satisfies Record<string, Pair>;
